// extracted by css-extract-rspack-plugin
export default {"wrapper":"_9879c058","isPDPDesktopAggregationVariant":"_6484f05c","isPdpDesktopAggregationVariant":"_6484f05c"};